import type { QueryProps } from "shared/react";
import type { AttemptData, ChallengeData, LeaderboardData } from "shared/schema";
import { splitEntity } from "shelving";
import { CardLoader, List, PathButton } from "shared/react";
import { useQuery } from "../util/db.js";
import { ChallengeCard } from "./ChallengeCard.js";

/** Get a list of challenges matching a query. */
export function ChallengeList({ query, ...props }: QueryProps<ChallengeData>): React.ReactElement {
	return (
		<List //
			store={useQuery("challenge", query)}
			mapper={({ id }) => (
				<CardLoader key={id}>
					<ChallengeCard id={id} />
				</CardLoader>
			)}
			{...props}
		/>
	);
}

/** Get a list of challenges from a list of attempts. */
export function AttemptChallengeList({ query, ...props }: QueryProps<AttemptData>): React.ReactElement {
	return (
		<List //
			store={useQuery("attempt", query)}
			mapper={({ cid }) => (
				<CardLoader key={cid}>
					<ChallengeCard id={cid} />
				</CardLoader>
			)}
			more="Show more challenges"
			empty="No challenges"
			{...props}
		/>
	);
}

/** Get a list of challenges from a list of leaderboards. */
export function LeaderboardChallengeList({ query, ...props }: QueryProps<LeaderboardData>): React.ReactElement {
	return (
		<List //
			store={useQuery("leaderboard", query)}
			mapper={({ cid, creator: target }) => {
				const [type, id] = splitEntity(target);
				return (
					<article key={id}>
						<CardLoader key={cid}>
							<ChallengeCard id={cid} />
						</CardLoader>
						<PathButton path={`/leaderboard/${type}/${id}/${cid}`}>Show leaderboard</PathButton>
					</article>
				);
			}}
			more="Show more challenges"
			empty="No challenges"
			{...props}
		/>
	);
}
